import React from 'react';
import '../css/GCPillButton.css';
import { useLanguage } from "../components/Language.js";

const GCPillButton = ({ onClick }) => {

  const {language} = useLanguage();
    
        const translations = {
            en: {
                gaelicConnect: "Gaelic Connect",
                   
            },
    
            gd: {
                gaelicConnect: "Ceangal Gàidhlig",
            },
          };
          
  return (
    <button className="GCPillbutton" onClick={onClick}>
      <h1>{translations[language].gaelicConnect}</h1>
    </button>
  );
};

export default GCPillButton;